module.exports = __webpack_public_path__ + "img/dot-003.fa513c02.svg";